module.exports = __webpack_public_path__ + "0af5d249/img/saly-icon.39e12342.jpg";